import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Differentiators } from './components/Differentiators';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { Testimonials } from './components/Testimonials';
import { ContactForm } from './components/ContactForm';
import { CtaBand } from './components/CtaBand';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { ChatBot } from './components/ChatBot';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />

      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Differentiators data-id="element-4" />
        <Services data-id="element-5" />
        <BeforeAfter data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Faq data-id="element-8" />
        <ContactForm data-id="element-9" />
        <CtaBand data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <ChatBot data-id="element-12" />
    </div>;
}